import { useQuery } from '@tanstack/react-query'

import { fetchReservationBoard } from '@/lib/venue/reservationApi'
import type { ReservationBoardView } from '@/lib/venue/reservationTypes'

export function reservationBoardQueryKey(venueId: string, date: string, courtId: number | 'ALL') {
  return ['venue', venueId, 'reservation-board', date, courtId] as const
}

export function useVenueReservationBoard(
  venueId: string,
  params: { date: string; courtId: number | 'ALL' }
) {
  return useQuery<ReservationBoardView>({
    queryKey: reservationBoardQueryKey(venueId, params.date, params.courtId),
    queryFn: () =>
      fetchReservationBoard(venueId, {
        date: params.date,
        courtId: params.courtId === 'ALL' ? undefined : params.courtId,
      }),
  })
}
